import { AsyncPipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {
  AppShellComponent,
  ButtonComponent,
  FormFieldComponent,
  HeaderComponent,
  HeaderModule,
  IconButtonComponent,
  IconComponent,
  LayerComponent,
  SearchComponent,
  SearchInputDirective,
  ToggleComponent,
} from '@totalenergiescode/tds-angular';
import { HomepageRoutingModule } from './homepage-routing.module';
import { HomepageComponent } from './homepage.component';
import { ToastDisplayerComponent } from '@app/toast-displayer/toast-displayer.component';

@NgModule({
    imports: [
        CommonModule,
        HomepageRoutingModule,
        RouterOutlet,
        HeaderModule,
        AppShellComponent,
        IconComponent,
        IconButtonComponent,
        ButtonComponent,
        AsyncPipe,
        RouterLink,
        RouterLinkActive,
        FormFieldComponent,
        SearchComponent,
        SearchInputDirective,
        NgTemplateOutlet,
        HeaderComponent,
        LayerComponent,
        ToggleComponent,
        HomepageComponent, ToastDisplayerComponent,
    ],
})
export class HomepageModule {}
